const ReservationAnswerStatus = Object.freeze({
    BLANK: { value: 'blank', text: 'Blank' },
    FILLED_IN: { value: 'filled_in', text: 'Filled in' },
});

export default ReservationAnswerStatus;
